export default class ChangeValuePopup {
  id;
  min;
  max;
  confirmCallback;
  increaseCallback;
  decreaseCallback;
  inputChangeCallback;
  value;
  position;
  title;
  shouldHideCloseButton;
  autoFocus;

  constructor(id,
              min,
              max,
              confirmCallback,
              increaseCallback,
              decreaseCallback,
              inputChangeCallback,
              value,
              position,
              title = "",
              shouldHideCloseButton = false,
              autoFocus = false
  ) {
    this.id = id;
    this.min = min;
    this.max = max;
    this.confirmCallback = confirmCallback;
    this.increaseCallback = increaseCallback;
    this.decreaseCallback = decreaseCallback;
    this.inputChangeCallback = inputChangeCallback;
    this.value = value;
    this.position = position;
    this.title = title;
    this.shouldHideCloseButton = shouldHideCloseButton;
    this.autoFocus = autoFocus;
  }
}
